import { render, staticRenderFns } from "./SimulationsCrud.vue?vue&type=template&id=4ea1a148&scoped=true"
import script from "./SimulationsCrud.vue?vue&type=script&lang=js"
export * from "./SimulationsCrud.vue?vue&type=script&lang=js"
import style0 from "./SimulationsCrud.vue?vue&type=style&index=0&id=4ea1a148&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea1a148",
  null
  
)

export default component.exports